// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.fee,\n.el-table th.fee {\n  width: 15em;\n}\n.el-table td.fee {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
